export default __webpack_public_path__ + "static/media/Believer's Wrist-straps of Shimmering Light.9400e196.jpg";